import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ProfileService } from '../../../../shared/services/profile.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import { FriendsService } from '../../../../shared/services/friends.service';
import { DecryptionService } from '../../../../shared/services/decryption.service';
@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  @ViewChildren('chartCanvas') chartCanvases!: QueryList<ElementRef>;
  profileUserData!: any;
  profilemember!: string | null;
  lastGamehistroy: any[] = [];
  friends: any[] = [];
  pagination = 1;
  statusValue = '';
  customclassprofileBoard = '';
  dataNotfund = false;
  statusinputShow!: boolean;
  statussetdata: any;
  statuShow: any;
  devices = ['all', 'win', 'loss', 'draw'];
  selectedresult: string = 'all';
  SortDate: string = 'descendingDate';
  isLoading = false;
  usergameDetails: any;
  currentTime!: Date;
  apiTime!: Date;
  timeDifference: any;
  ratingData: any[] = [];
  puzzleBox = '';
  chartInstances: Chart[] = [];
  public charts: any[] = [];
  friendButtonLabel: string = '';


  constructor(
    private profileData: ProfileService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private friendData: FriendsService, private decryptionApi: DecryptionService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.profilemember = this.activatedRoute.snapshot.paramMap.get('username');
    this.statuShow = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.profileuser();
    this.gamedetails();
    this.puzzleBox =
      this.statuShow.username == this.profilemember ? 'user-profile-game-box' : 'player-profile-game-box';
    this.profileData.usernameData.subscribe({
      next: (res) => {
        if (res) {
          this.profilemember = res;
          this.getUserData();
        }
      },
    });
  }

  ngAfterViewInit() {
    this.RatingChartData();
    this.chartboardChanges();
  }

  chartboardChanges() {
    Chart.register(...registerables);
  }

  RatingChartData() {
    this.chartCanvases.changes.subscribe((canvases: QueryList<ElementRef>) => {
      this.renderCharts(canvases.toArray());
    });

    this.renderCharts(this.chartCanvases.toArray());
  }

  profileuser() {
    this.profileData.profileData(this.profilemember).subscribe({
      next: (res) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.playerRelations(res.messages);
        this.profileUserData = jsondecrpt;
        this.friends = jsondecrpt.friends;
        this.ratingData = jsondecrpt.ratings;
        this.prepareChartData(jsondecrpt.ratings);
        this.statusValue = this.profileUserData.status;
        this.currentTime = new Date();
        this.apiTime = new Date(this.profileUserData.lastOnline);
        this.timeDifference =
          this.currentTime > this.apiTime
            ? this.currentTime.getTime() - this.apiTime.getTime()
            : null;
      },
      error: (error) => {
        if (!error.error.success) {
          this.router.navigate(['empty']);
        }
      },
    });
  }

  formatTimeDifference(milliseconds: number): string {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
      return `${seconds} second${seconds !== 1 ? 's' : ''} ago`;
    }
  }

  onChange(deviceValue: any) {
    this.lastGamehistroy = [];
    this.pagination = 1;
    this.selectedresult =
      deviceValue.target.value === 'all' ? '' : deviceValue.target.value;
    this.gamedetails();
  }

  statusData(data: any) {
    const inputValue = {
      status: data,
    };
    this.statusinputShow = false;
    this.profileData.profileupdateData(inputValue).subscribe((res) => {
      this.statussetdata = data;
    });
  }

  gamedetails() {
    this.profileData
      .profileGameData(
        this.profilemember,
        this.pagination,
        this.selectedresult,
        this.SortDate
      )
      .subscribe((data: any) => {
        const decrypt = this.decryptionApi.decrypt(data.payload);
        const jsondecrpt = JSON.parse(decrypt);
        if (jsondecrpt.games) {
          this.isLoading = false;
        }
        this.usergameDetails = jsondecrpt.games;
        this.lastGamehistroy.push(...this.usergameDetails);
        if (this.lastGamehistroy.length > 7) {
          return (this.customclassprofileBoard = 'table-responsive');
        } else {
          return (this.customclassprofileBoard = 'table-scroll-responsive');
        }
      });
  }

  statusinput() {
    this.statusinputShow = true;
  }

  friendprofile(data: any) {
    this.profilemember = data;
    this.lastGamehistroy = [];
    this.router.navigate(['profile', this.profilemember]);
    this.profileuser();
    this.gamedetails();
    this.RatingChartData();
    this.chartboardChanges();
  }

  friendlist() {
    this.router.navigate(['friends']);
  }

  editprofile() {
    this.router.navigate(['settings']);
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (this.usergameDetails.length == 0 || this.usergameDetails.length < 10) {
      return;
    }
    if (scrollPosition >= totalHeight - 1) {
      this.isLoading = true;
      this.pagination++;
      this.gamedetails();
    }
  }

  descendingDate(data: string) {
    this.lastGamehistroy = [];
    this.SortDate = data;
    this.pagination = 1;
    this.gamedetails();
  }

  ascendingDate(data: string) {
    this.lastGamehistroy = [];
    this.SortDate = data;
    this.pagination = 1;
    this.gamedetails();
  }

  gameHistory(data: any) {
    this.router.navigate(['play', data]);
  }

  puzzlePage() {
    this.router.navigate(['puzzle/complatedpuzzle']);
  }

  prepareChartData(ratings: any) {
    this.charts = [];

    const ratingTypes = ['blitz', 'bullet', 'rapid', 'puzzle'];
    ratingTypes.forEach((type) => {
      if (ratings[type].history && ratings[type].history.length > 0) {
        this.charts.push({
          title: type.charAt(0).toUpperCase() + type.slice(1),
          win: ratings[type].record?.win,
          lost: ratings[type].record?.loss,
          draw: ratings[type].record?.draw,
          nowrating: ratings[type].last?.rating,
          chartshow: true,
          data: [
            {
              data: ratings[type].history.map((entry: any) => entry.rating),
              label: `${type.charAt(0).toUpperCase() + type.slice(1)} Ratings`,
            },
          ],
          labels: ratings[type].history.map((entry: any) =>
            new Date(entry.date).toLocaleDateString()
          ),
        });
      }
    });
  }
  renderCharts(canvasElements: ElementRef[]) {
    this.chartInstances.forEach((chart) => chart.destroy());
    this.chartInstances = [];

    let canvasIndex = 0;

    this.charts.forEach((chart, index) => {
      if (!chart.chartshow) {
        return;
      }

      const canvasElement = canvasElements[canvasIndex];
      canvasIndex++;

      if (!canvasElement) {
        return;
      }

      const canvas = canvasElement.nativeElement as HTMLCanvasElement;
      const ctx: any = canvas.getContext('2d');

      const chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: chart.labels,
          datasets: chart.data[0].data.length
            ? [
              {
                data: chart.data[0].data,
                label: chart.title,
                borderColor: '#3e95cd',
                fill: true,
                pointStyle: 'circle',
              },
            ]
            : [],
        },
        options: {
          responsive: true,
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: 'Date',
              },
              grid: {
                display: false, // Hide x-axis grid lines
              },
            },
            y: {
              display: true,
              title: {
                display: true,
                text: 'Rating',
              },
              grid: {
                display: false, // Hide y-axis grid lines
              },
            },
          },
        },
      });

      this.chartInstances.push(chartInstance);
    });
  }

  sendFriendRequest(data: any) {
    this.friendData.friendReqeust({ username: data }).subscribe({
      next: (res) => { },
    });
  }

  removeFriendList(data: any) {
    this.friendData.removefriend({ username: data }).subscribe({
      next: (res) => { },
    });
  }

  getUserData() {
    this.lastGamehistroy = [];
  }

  playerRelations(data: any) {
    switch (data) {
      case 'friends':
        this.friendButtonLabel = 'Unfriend';
        break;
      case 'cancelReq':
        this.friendButtonLabel = 'Cancel Request';
        break;
      case 'acceptReq':
        this.friendButtonLabel = 'Accept Request';
        break;
      case 'notFriend':
        this.friendButtonLabel = 'Follow';
        break;
    }
  }

  toggleFriendRequest(data: any) {
    if (this.friendButtonLabel === 'Follow') {
      this.friendData.friendReqeust({ username: data }).subscribe({
        next: (res) => {
          this.friendButtonLabel = 'Cancel Request';
        },
      });
    } else if (this.friendButtonLabel === 'Unfriend') {
      this.friendData.removefriend({ username: data }).subscribe({
        next: (res) => {
          this.friendButtonLabel = 'Follow';
        },
      });
    } else if (this.friendButtonLabel === 'Accept Request') {
      this.friendData.acceptfriend({ username: data }).subscribe({
        next: (res) => {
          this.friendButtonLabel = 'Unfriend';
        },
      });
    } else if (this.friendButtonLabel === 'Cancel Request') {
      this.friendData.sentrequestCancel({ username: data }).subscribe({
        next: (res) => {
          this.friendButtonLabel = 'Follow';
        },
      });
    }
  }
}
